import { Component } from '@angular/core';
import { SiqCommonModule } from '@shared/siq-common.module';
import { SiqDateFormats } from '@shared/utils/helpers/date-formats.helper';
import { LinksHelper } from '@shared/utils/helpers/links-helper';
import * as moment from 'moment';

@Component({
  selector: 'app-siq-footer',
  templateUrl: './siq-footer.component.html',
  standalone: true,
  imports: [SiqCommonModule]
})
export class SiqFooterComponent {
  year =  moment().format(SiqDateFormats.Year);

  getLink(link: keyof typeof LinksHelper): string {
    const value = LinksHelper[link];
    if (typeof value === 'string') {
      return value;
    }
    return '';
  }
}